import React, { useState, useEffect } from "react";
import {
    Box,
    CircularProgress,
    Typography,
    useTheme,
    MenuItem,
    FormControl,
    InputLabel,
    Select
} from "@mui/material";
import Header from "../../components/Header";
import { tokens } from "../../theme";

const forms = [
    { name: "LiquidOffice", url: "https://liquidoffice.collierschools.com" },
    { name: "MIS Requests", url: "https://liquidoffice.collierschools.com/lfserver/MIS_Requests" }
];

const API_VERSION = 'v1';
const SERVER_URL = 'https://liquidoffice.collierschools.com';

const LiquidOffice = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [selectedForm, setSelectedForm] = useState(forms[0]);
    const [loToken, setLoToken] = useState(null);
    const [iframeUrl, setIframeUrl] = useState('');

    // Authenticate and build iframe URL on form change
    useEffect(() => {
        const authenticate = async () => {
            setLoading(true);
            setError(null);
            try {
                const resp = await fetch(`${SERVER_URL}/loapi/${API_VERSION}/auth`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        username: 'administrator',
                        password: '1FellSw00p!'
                    })
                });
                if (!resp.ok) throw new Error(`Authentication failed: ${resp.status}`);
                const data = await resp.json();
                const token = data['lo-token'] || data['session-key'] || data['token'];
                setLoToken(token);
                // Append token as query param so LO recognizes the session
                const url = new URL(selectedForm.url);
                url.searchParams.set('lo-token', token);
                setIframeUrl(url.toString());
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        authenticate();
    }, [selectedForm]);

    const handleFormChange = (event) => {
        const newSelection = forms.find(form => form.name === event.target.value);
        setSelectedForm(newSelection);
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
                overflow: "hidden",
                backgroundColor: colors.background
            }}
        >
            <Box sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
                <Header
                    title="Mobile Inventory Entry"
                    subtitle="Select a form from the dropdown below."
                />

                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        padding: "16px",
                        backgroundColor: colors.primary[900],
                        borderRadius: "8px",
                        marginTop: "16px"
                    }}
                >
                    <FormControl
                        variant="outlined"
                        sx={{
                            width: "300px",
                            marginRight: "16px",
                            "& .MuiInputLabel-root": { color: colors.grey[100] },
                            "& .MuiSelect-select": { color: colors.grey[100] },
                            "& .MuiOutlinedInput-notchedOutline": { borderColor: colors.grey[500] }
                        }}
                    >
                        <InputLabel>Choose Form</InputLabel>
                        <Select
                            value={selectedForm.name}
                            onChange={handleFormChange}
                            label="Choose Form"
                            sx={{ "& .MuiSvgIcon-root": { color: colors.grey[100] } }}
                        >
                            {forms.map(form => (
                                <MenuItem key={form.name} value={form.name}>
                                    {form.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>

                <Box
                    sx={{
                        flex: 1,
                        position: "relative",
                        borderRadius: "8px",
                        overflow: "hidden",
                        marginTop: "16px",
                        backgroundColor: colors.primary[900],
                        padding: "16px"
                    }}
                >
                    {loading ? (
                        <CircularProgress />
                    ) : error ? (
                        <Typography color="error">{error}</Typography>
                    ) : (
                        <iframe
                            title={selectedForm.name}
                            src={iframeUrl}
                            style={{
                                width: "100%",
                                height: "100%",
                                border: "none",
                                borderRadius: "8px",
                                backgroundColor: colors.primary[800]
                            }}
                        />
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default LiquidOffice;
